export default {
  get: { method: 'get', url: '/conf' } // 系统配置
}
